import { ISelfServeContextIdvResponse } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeContextIdvResponse";

/**
 * Designed to store API calls that we don't want to repeat when resolving visibility of nodes
 */
interface IApiPromises {
  idv: Promise<ISelfServeContextIdvResponse> | undefined;
}

export const apiPromises: IApiPromises = {
  idv: undefined,
};
